import React from 'react'
import { Title, Text } from '../styled'
import styled from 'styled-components'
import mediaQuery from '../../../styles/mediaQuery'

const StyledTitle = styled(Title)`
  font-size: 40px;
  font-weight: 300;
  line-height: 1.1;
  text-align: left;
  color: var(--black-carbon);

  ${mediaQuery.bigTabletMin} {
    font-size: 80px;
    margin-top: 72px;
    max-width: 568px;
  }
`

const StyledText = styled(Text)`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  color: var(--red-dark);

  ${mediaQuery.bigTabletMin} {
    font-size: 20px;
    max-width: 545px;
  }
`

const translations = {
  header: 'Start selling on Flip today',
  descriptonFirst:
    'Join Flip, the full-service shopping social network that connects top brands with real shoppers. With our hassle-free sign-up, be a part of our growing community within a week – no initial costs needed. ',
  descriptonSecond:
    'At Flip, we elevate your shopping experience with our meticulously handpicked brands. We offer a transparent pricing model based on the SRP of each product sold, ensuring your journey on our platform is as straightforward as it is successful.',
}

const FormInfo = () => (
  <div>
    <StyledTitle>{translations.header}</StyledTitle>
    <StyledText>{translations.descriptonFirst}</StyledText>
    <StyledText>{translations.descriptonSecond}</StyledText>
  </div>
)

export default FormInfo
